module.exports = __webpack_public_path__ + "img/Porto Apartment - 13 of 85.e561260e.jpeg";